<template>
  <v-flex xs12 md6>
    <v-card class="client campaign ma-1 pa-2 text--darken-4">
      <v-card-title>
        <div>
          <div class="title">{{ value.campaignable.name }}</div>
          <span>{{ `${root}/campaign/${value.slug}` }}</span>
        </div>
        <v-spacer />
        <v-tooltip left><span>Archive</span>
          <v-btn flat icon slot="activator" :color="themes.client.light.muted" @click="archive">
            <v-icon>mdi-archive-arrow-down</v-icon>
          </v-btn>
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-actions>
        <v-dialog v-model="dialogQR" lazy absolute width="320px">
          <v-btn flat :color="themes.client.light.secondaryActionButton" class="darken-2" slot="activator">
            <v-icon left>mdi-qrcode</v-icon> View QR
          </v-btn>
          <v-img>
            <VueQr
              :size="320"
              :margin="0"
              :text="`${root}/campaign/${value.slug}`"
            />
          </v-img>
        </v-dialog>

        <v-spacer />

        <v-dialog v-model="dialog" lazy absolute max-width="320px">
          <v-btn flat color="red" slot="activator">
            <v-icon left>mdi-delete</v-icon> Delete
          </v-btn>
          <v-card>
            <v-card-title>
              <div class="headline">Delete campaign</div>
            </v-card-title>
            <v-card-text>
              This will remove all connections to users that used this campaign to
              sign up and it will no longer show up in reporting. <strong>Are you sure about this?</strong>
            </v-card-text>
            <v-card-actions><v-spacer />
              <v-btn :color="themes.client.light.secondaryActionButton" flat @click.native="dialog = false">cancel</v-btn>
              <v-btn color="red" dark @click="destroy">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
// Components
import VueQr from 'vue-qr'

// Vue Component
export default {
  props: {
    value: Object,
    organization: Object,
  },
  components: { VueQr },
  data() {
    return { dialogQR: false, dialog: false, root: Vue.root }
  },
  methods: {
    destroy() {
      this.$store.dispatch('client/campaigns/destroy', this.value.slug).then(
        // Success
        response => {
          this.$store.commit('snackbar', {
            text: 'Campaign deleted',
            type: 'success',
          })
          this.$store.dispatch('client/campaigns/fetchAll')
        },
        // Failure
        errors =>
          this.$store.commit('snackbar', {
            text: 'There was a problem deleting the campaign',
            type: 'error',
          })
      )
    },
    archive() {
      this.$store.dispatch('client/campaigns/update', Object.assign(this.value, { hiddenAt: new Date()}))
        .then(
        // Success
        response => {
          this.$store.commit('snackbar', {
            text: 'Campaign archived',
            type: 'success',
          })
          this.$store.dispatch('client/campaigns/fetchAll')
        },
        // Failure
        errors =>
          this.$store.commit('snackbar', {
            text: 'There was a problem archiving the campaign',
            type: 'error',
          })
      )
    },
  },
}
</script>

<style lang="scss">
.client.campaign.card {
  width: 320px;

  .card__title {
    margin-top: -16px !important;
  }
}
</style>
